import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IVendorOfferListResponse, IVendorOfferWithoutVendorConfiguration} from "../../offer/types/VendorOffersListResponse";
import {VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE} from "../constants/vendor_detail_offers_max_page_size";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

export const getVendorDetailAllActiveOffers = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getVendorDetailAllActiveOffers: builder.query<IVendorOfferListResponse, IVendorDetailOfferListParams>({
            queryFn: async (params, _api, _extraOptions, fetchBaseQuery) => {
                const queryArgs = {
                    url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                    method: "GET",
                    params
                };

                const response = await fetchBaseQuery(queryArgs);

                if (response.error) {
                    return {error: response.error};
                }

                const responseData = response.data as IVendorOfferListResponse;
                const offersCount = responseData.count || 0;
                const offerList = responseData.results || [];
                //numbers of pages for additional fetches, general number of pages - first page
                const additionalFetchCount = Math.ceil(offersCount / (params.page_size || VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE)) - 1;

                const finalResults = offerList;

                if (offersCount > offerList.length) {
                    //array build on number of fetches needed, example 2 -> [0,1]
                    const promises = Array.from(Array(additionalFetchCount).keys()).map((number) => {
                        return fetchBaseQuery({
                            ...queryArgs,
                            params: {...queryArgs.params, page: (queryArgs.params.page || 1) + number + 1}
                        }) as {data: IVendorOfferListResponse; error?: FetchBaseQueryError};
                    });

                    const additionalResults: IVendorOfferWithoutVendorConfiguration[] = [];
                    const additionalErrors: FetchBaseQueryError[] = [];

                    const resultArray = await Promise.all(promises);

                    resultArray.forEach((el) => {
                        if (typeof el.error !== "undefined") {
                            additionalErrors.push(el.error);
                            return;
                        }
                        additionalResults.push(...(el.data.results || []));
                    });

                    if (additionalErrors.length > 0) {
                        return {error: additionalErrors[0]};
                    }

                    if (additionalResults.length > 0) {
                        finalResults.push(...additionalResults);
                    }
                }

                return {
                    data: {
                        count: responseData.count,
                        page: 1,
                        page_size: responseData.count,
                        next: null,
                        previous: null,
                        results: finalResults
                    }
                };
            }
        })
    })
});

export const {useGetVendorDetailAllActiveOffersQuery} = getVendorDetailAllActiveOffers;
